import { FC } from 'react';

import { Link } from '@inertiajs/react';

import { Routes } from '../../models/routes';
import { Universe } from '../../types';
import { cn } from '../../utils';

interface Props {
    universes: Pick<Universe, 'id' | 'name' | 'slug'>[];
    selectedUniverseSlug: string | null;
    searchQuery: string;
}

export const SellerUniverseFilter: FC<Props> = ({
    universes,
    selectedUniverseSlug,
    searchQuery,
}) => {
    if (universes.length <= 1) return null;

    const items = [
        {
            key: 'all',
            href: sellerFilterUrl(null, searchQuery),
            label: 'Усі ігри',
            slug: null,
            testId: 'seller-universe-filter-all',
        },
        ...universes.map((universe) => ({
            key: String(universe.id),
            href: sellerFilterUrl(universe.slug, searchQuery),
            label: universe.name,
            slug: universe.slug,
            testId: `seller-universe-filter-${universe.slug}`,
        })),
    ];

    return (
        <div
            className="scrollbar-hide -mx-1 flex w-auto items-center gap-2.5 overflow-x-auto overflow-y-hidden px-1"
            data-testid="seller-universe-filter"
        >
            <nav
                className="flex flex-nowrap gap-2"
                aria-label="Фільтр продавців за грою"
            >
                {items.map((item) => {
                    const active = selectedUniverseSlug === item.slug;

                    return (
                        <Link
                            key={item.key}
                            href={item.href}
                            aria-current={active ? 'page' : undefined}
                            data-testid={item.testId}
                            className={cn(
                                'inline-flex min-h-9 shrink-0 items-center justify-center rounded-full border px-3 text-xs font-medium whitespace-nowrap transition-colors',
                                active
                                    ? 'border-primary bg-primary/10 text-primary'
                                    : 'border-border bg-background text-muted-foreground hover:border-primary/30 hover:text-foreground',
                            )}
                        >
                            {item.label}
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
};

const sellerFilterUrl = (universeSlug: string | null, searchQuery: string) => {
    const queryParams = new URLSearchParams();

    if (universeSlug) queryParams.set('universe', universeSlug);
    if (searchQuery) queryParams.set('search', searchQuery);

    const queryString = queryParams.toString();
    return queryString ? `${Routes.Sellers}?${queryString}` : Routes.Sellers;
};
